import { computed, type Ref } from 'vue'
import scssVariables from '@/assets/scss/scssVariables'

import { RESOURCE_STATUS, type ResourceStatus } from '@/constants/persoplan'
import { type Nilable } from '@/types/misc'

export { type ResourceStatus, RESOURCE_STATUS }

interface Options {
  status: Ref<Nilable<ResourceStatus>>
}

const colors = {
  notAvailable: scssVariables.color['status-resourceDay-notAvailable'],
  availableIfUrgent:
    scssVariables.color['status-resourceDay-availableIfUrgent'],
  available: scssVariables.color['status-resourceDay-available'],
  storage: scssVariables.color['status-resourceDay-storage'],
  onProject: scssVariables.color['status-resourceDay-onProject'],
} as const satisfies Record<ResourceStatus, string>

export function useResourceDayStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusResourceDay-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    if (!options.status.value) return

    return colors[options.status.value]
  })

  return {
    classes,
    color,
  }
}
